import ApiController, { ApiRequest } from "../controller";

class AuthModule extends ApiController {
  resource = "/auth";

  login(location, email, password) {
    const data = {
      location: { id: location.id },
      email,
      password
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/login`,
      body: data
    });

    return this.request<any>(request);
  }

  loginEmailAuth(location, email, code, auth, expires) {
    const data = {
      location: { id: location.id },
      email,
      code,
      auth,
      expires
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/loginEmailAuth`,
      body: data
    });

    return this.request<any>(request);
  }

  loginCodeRequest(location, customer, email) {
    const data = {
      location: { id: location.id },
      customer: { id: customer.id },
      email
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/loginCodeRequest`,
      body: data
    });

    return this.request<any>(request);
  }

  loginCodeAuth(location, customer, email, token, code) {
    const data = {
      location: { id: location.id },
      customer: { id: customer.id },
      email,
      token,
      code
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/loginCodeAuth`,
      body: data
    });

    return this.request<any>(request);
  }

  connectLogin(email, password) {
    const data = {
      email,
      password
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/connectLogin`,
      body: data
    });

    return this.request<any>(request);
  }

  user() {
    const request = new ApiRequest({
      method: "GET",
      url: `/user`
    });

    return this.request<any>(request);
  }

  connectedAccounts() {
    const request = new ApiRequest({
      method: "GET",
      url: `/connectedAccounts`
    });

    return this.request<any>(request);
  }

  sendRecoveryEmail(location, email) {
    const data = {
      location: { id: location.id },
      email
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/sendRecoveryEmail`,
      body: data
    });

    return this.request<any>(request);
  }

  resetPassword(location, code, password) {
    const data = {
      location: { id: location.id },
      code,
      password
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/resetPassword`,
      body: data
    });

    return this.request<any>(request);
  }

  changePassword(currentPassword, newPassword) {
    const data = {
      currentPassword,
      newPassword
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/changePassword`,
      body: data
    });

    return this.request<any>(request);
  }

  resendLoginEmail(location, email, code, auth, expires, redirect) {
    const data = {
      location: { id: location.id },
      email,
      code,
      auth,
      expires,
      redirect
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/resendLoginEmail`,
      body: data
    });

    return this.request<any>(request);
  }
}

export default AuthModule;